export default {
  kpi_chart: '/kpichart',
  profile: '/profile',
  leave_applications: '/leave-applications',
  myleave: '/my-leave',
  promises: '/promises',
  tasks: {
   'tasks': '/tasks',
   'assignee_section': 'assignee',
   'owner_section': 'owner',
   'viewer_section': 'viewer',
    },
  courses: '/my-course',
  setup_courses: '/courses',
}
